import Layout from '@/layouts/BasicLayout/index.vue'
import type { RouteRecordRaw } from 'vue-router'

const baseInfo: RouteRecordRaw = {
  path: '/base-info',
  name: 'BaseInfo',
  redirect: '/base-info/account-info-manage',
  component: Layout,
  meta: {
    title: '基础信息',
    module: 'BASE_INFO',
    icon: 'base-info|svg'
  },
  children: [
    {
      path: 'account-info-manage',
      name: 'AccountInfoManage',
      component: () => import('@/views/BaseInfo/AccountInfoManage/index.vue'),
      meta: {
        title: '账号信息管理',
        module: 'ACCOUNT_INFO_MANAGE'
      }
    }
  ]
}

export default baseInfo
